
import * as angular from "angular";
import * as moment from "moment";
import { IDriver } from "@interfaces/IDriver";
import { IJourney } from "@interfaces/IJourney";
import { IPlotEvent } from "@interfaces/IPlot";
import { IVehicle } from "@interfaces/IVehicle";
import "./journeySummary.scss";

export enum EventAction {
    Selected,
    Hover
}

interface IJourneySummaryComponentBindings {

    showIntervalAbove: boolean;
    journey: IJourney;
    vehicle: IVehicle;
    driver: IDriver;

    onClick: (args: { journey: IJourney }) => void;
    onMouseover: (args: { journey: IJourney }) => void;
    onEventAction: (args: { journey: IJourney, event: IPlotEvent, mouseAction: EventAction }) => void;
}

// Todo: Rename to journey-card ?
class JourneySummaryComponentController implements angular.IComponentController, IJourneySummaryComponentBindings {

    showIntervalAbove: boolean;
    journey: IJourney;
    vehicle: IVehicle;
    driver: IDriver;

    journeyEvents: IPlotEvent[];

    onClick: (args: { journey: IJourney }) => void;
    onMouseover: (args: { journey: IJourney }) => void;
    onEventAction: (args: { journey: IJourney, event: IPlotEvent, mouseAction: EventAction, mouseEvent: MouseEvent }) => void;

    hasMultipleEvents: boolean;
    hideEvents: boolean;

    static $inject = [];

    constructor() {
    }

    $onInit() {
        this.hideEvents = true;
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        this.hideEvents = true;

        if (onChangesObj["journey"]) {
            this.journey.events = this.journey.events || [];

            this.journey.events.sort((a, b) => {
                return moment(a.plot.UtcMoment).isBefore(b.plot.UtcMoment) ? -1 : 1;
            });

            this.hasMultipleEvents = this.journey.events.length > 2;
            this.hideEvents = this.hasMultipleEvents;

            this.updateEvents();
        }
    }

    toggleHideEvents() {
        this.hideEvents = !this.hideEvents;

        this.updateEvents();
    }

    journeyClicked() {
        if (this.onClick) {
            this.onClick({ journey: this.journey });
        }
    }

    journeyMouseOver() {
        if (this.onMouseover) {
            this.onMouseover({ journey: this.journey });
        }
    }

    eventClicked(event: IPlotEvent, $event: MouseEvent) {
        if (this.onEventAction) {
            this.onEventAction({ journey: this.journey, event: event, mouseAction: EventAction.Selected, mouseEvent: $event });
        }
    }

    eventMouseHover(event: IPlotEvent, $event: MouseEvent) {
        if (this.onEventAction) {
            this.onEventAction({ journey: this.journey, event: event, mouseAction: EventAction.Hover, mouseEvent: $event });
        }
    }

    // ----------------

    private updateEvents() {
        this.journeyEvents = [];

        this.journey.events.forEach((event, i) => {
            if (!this.hideEvents || i == 0 || i == this.journey.events.length - 1) {
                this.journeyEvents.push(event);
            }
        });
    }
}

export class JourneySummaryComponent implements angular.IComponentOptions {
    bindings: any;
    template: string;
    controller: any;

    constructor() {
        this.bindings = {
            vehicle: "<",
            driver: "<",
            journey: "<",

            selected: "<",

            showIntervalAbove: "<",

            onClick: "&",
            onEventAction: "&",
            onMouseover: "&"
        };

        this.controller = JourneySummaryComponentController;

        this.template = require("./journeySummary.html");
    }
}
